<template lang="pug">
  div
    div.wrap-visualization
      ModuleVisualization(v-if="slide && pages[0] && doodles && messages"
        :slide="slide" :pages="pages" :doodles="doodles" :messages="messages")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-visualization {
  
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
// import Auth from '@/components/shared/Auth'
import Header from '@/components/shared/Header'
import ModuleVisualization from '@/components/module/ModuleVisualization'

export default {
  components: {
    // Auth,
    Header,
    ModuleVisualization
  },
  data () {
    return {
      slide: null,
      pages: [],
      doodles: [],
      messages: []
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  created () {
    database.slideCollection()
      .getSlideInRealtime(this.$route.params.slideId, this.updateSlide)
    
    database.slideCollection()
      .getDoodlesAscCreatedAtInRealtime(this.$route.params.slideId, this.updateDoodles)
    
    database.slideCollection()
      .getMessageInRealtime(this.$route.params.slideId, this.updateMessages)
  },
  methods: {
    async updateSlide (d) {
      this.slide = d.data()

      const pages = await database.slideCollection()
        .getPages(this.$route.params.slideId)
      this.pages = this.slide.pageDocs.map(pdId => {
        return pages.filter(p => p.id === pdId)[0]
      })
    },
    updateDoodles (q) {
      this.doodles = q.docs.map(d => {
        return { id: d.id, ...d.data() }
      })
    },
    updateMessages (q) {
      this.messages = q.docs.map(d => {
        return { id: d.id, ...d.data() }
      })
    }
  }
}
</script>
